import * as Sentry from '@sentry/react'

export type Reporter = (error: unknown, context?: Record<string, unknown>) => void
export const report: Reporter = (...args) => {
  // eslint-disable-next-line import/namespace
  Sentry.captureException(...args)
}
